<template>
  <div v-if="!!tender && tender.tenderId">
    <div class="h4-headline text-start pb-5 pt-4">
      {{ bids.length }} {{ $tc('Tenders.Proposals', bids.length ) }}
    </div>
    <div
      v-for="(lot, n) in groups"
      :key="n"
      class="pb-4 text-left">
      <div class="py-4 h4-headline">
        {{ n + 1 }}. {{ lot.title }}
      </div>
      <v-simple-table
        class="main__green">
        <template #default>
          <thead>
            <tr class="header">
              <th class="modal-column cell secondary__green_chosen"/>
              <th
                v-for="(lotItem, lotItemIndex) in lot.items"
                :key="lotItem ? lotItem.index : lotItemIndex"
                class="organisation-cell cell px-2 h7-text-medium secondary__green_chosen black--text"
                cols="2">
                <div class="flex flex-wrap align-center">
                  <v-checkbox
                    v-if="canEdit && !lotItem.placeholder"
                    v-model="selected"
                    class="ma-0 mr-3 pa-0"
                    color="var(--black-color)"
                    hide-details
                    :ripple="false"
                    :value="lotItem"/>
                  {{ lotItem && lotItem.bidderInfo ? lotItem.bidderInfo.organizationName : '' }}
                  <ExternalParticipantChip
                    v-if="lotItem.foreignBidderBid"
                    class="ml-3"/>
                </div>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(key, index) in keys"
              :key="n + '' + index"
              class="info-row">
              <td class="text-start modal-column cell">
                {{ key.text }}
              </td>
              <td
                v-for="(lotItem, lotItemIndex ) in lot.items"
                :key="lotItemIndex + '' + (lotItem ? lotItem.index : lotItemIndex)"
                class="text-start info-cell cell"
                :class="{'bold': key.value == 'price' }">
                <ComparativeTableCell
                  v-if="lotItem"
                  :field="key"
                  :item="lotItem"
                  :muted="$_getSame(key.value, lot.items)"
                  :tender="tender"/>
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </div>
  </div>
</template>
<script>
import ExternalParticipantChip from 'components/tenders/tender page/ExternalParticipantChip.vue'
import ComparativeTableCell from 'pages/tender item/ComparativeTableCell.vue'

import { tenderMixin, snackbarMixin, modalMixin } from 'mixins'
import comparativeTableMixin from 'mixins/comparativeTableMixin'

export default {
  name: 'ComparativeTableDefault',
  mixins: [ tenderMixin, snackbarMixin, modalMixin, comparativeTableMixin ],
  computed: {
    keys() {
      let keys = [
        {
          text: this.$t('Catalog.Price'),
          value: 'price'
        },
        {
          text: this.$t('Catalog.Amount'),
          value: 'quantity'
        },
        {
          text: this.$t('Catalog.TotalCost'),
          value: 'summ'
        },
        {
          text: this.$t('Tenders.DateOfSubmission'),
          value: 'timeSupplyBids'
        },
        {
          text: this.$t('Tenders.AdditionalInfoLot'),
          value: 'additionalInfo'
        },
        {
          text: this.$t('Tenders.AdditionalInfoTEnder'),
          value: 'remark'
        },
      ]

      if (this.tender.biddingType.tenderingForPercentage) {
        const item = keys.find(i => i.value === 'price')
        item.text = this.$t('Tenders.DiscountPercentage')
      }
      return keys.concat(this.$_defaultCriteriaKeys(this.bids), this.$_criteriaKeys(this.bids))
    },
    groups() {
      let bids = this.bids,
        grouped_bids = this.$_.groupBy(bids, 'lotId'),
        orgs = this.$_.groupBy(bids, 'org_num')

      grouped_bids = Object.values(grouped_bids).map(el => {
        let items = this.$_.groupBy(el, 'org_num')
        Object.keys(orgs).forEach(org => {
          // Заглушка колонки: постачальник не подавав пропозицію на цей лот, обирати в ній нічого
          items[org] = items[org] || [{bidderInfo: orgs[org][0].bidderInfo, placeholder: true}]
        })

        let its = Object.values(items), res = {
          title: el[0].lotTitle,
          items: []
        }
        its.forEach(el => res.items.push(...el))
        return res
      })
      return grouped_bids
    },
  },
  components: {
    ExternalParticipantChip,
    ComparativeTableCell
  },
  props: {
    tender: {
      type: Object,
      required: true
    },
    bids: {
      type: Array,
      required: true
    },
    canEdit: {
      type: Boolean,
      default: false
    },
  },
}
</script>
<style scoped>
</style>
